import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { toast } from 'sonner';
import { z } from 'zod';
import Honeybadger from '@honeybadger-io/js';
import { zodResolver } from '@hookform/resolvers/zod';

import { SUCCESS_MESSAGES } from '../constants';
import { createDecedent as apiCreateDecedent } from '../services/decedentService';

const defaultValues = {
  firstName: '',
  lastName: '',
};

const formSchema = z.object({
  firstName: z.string().min(1, 'First name is required.'),
  lastName: z.string().min(1, 'Last name is required.'),
});

const useDecedentForm = ({ onClose, onSuccess }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues,
  });

  const handleSuccess = () => {
    onClose();
    onSuccess();
    toast.success(SUCCESS_MESSAGES.decedent.create);
    form.reset();
  };

  const handleSubmit = async (formData) => {
    try {
      setErrorMessage('');
      setIsSubmitting(true);

      await apiCreateDecedent(formData);

      handleSuccess();
    } catch (error) {
      setErrorMessage(error.message);
      Honeybadger.notify(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenChange = (open) => {
    if (!open) {
      onClose();
      setErrorMessage('');
      form.reset();
    }
  };

  return {
    errorMessage,
    form,
    handleOpenChange,
    handleSubmit,
    isSubmitting,
  };
};

export default useDecedentForm;
